export default __webpack_public_path__ + "static/media/userjourney2.6129249b.png";